/* Storefront filtering: auto-submit filter forms, debounce price, JS-navigate on sort change.
   Full page reloads (no SPA) keep this simple and robust. Drawer open/close is global.js. */
(function () {
  function submitForm(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  // Auto-submit when a checkbox/radio filter changes
  document.addEventListener('change', function (e) {
    var input = e.target;
    var form = input.closest && input.closest('[data-facets-form]');
    if (!form) {
      // Sort selects live in the toolbar (outside the form) and inside the rail.
      if (input.matches && input.matches('[data-sort-select]')) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', input.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }
      return;
    }
    if (input.matches('[data-sort-select]')) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', input.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
      return;
    }
    if (input.matches('[data-facets-price]')) return; // handled below with debounce
    if (input.type === 'checkbox' || input.type === 'radio') submitForm(form);
  });

  // Debounced price submit
  var timer = null;
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-facets-price]')) return;
    var form = input.closest('[data-facets-form]');
    if (!form) return;
    clearTimeout(timer);
    timer = setTimeout(function () { submitForm(form); }, 700);
  });

  // Enter in a price field submits immediately
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (input.matches && input.matches('[data-facets-price]')) {
      e.preventDefault();
      clearTimeout(timer);
      var form = input.closest('[data-facets-form]');
      if (form) submitForm(form);
    }
  });
})();
